/**
 * 评论表单
 * @author Jianbo
 * @time 2020-03-17
 */

class CommentForm {
  // 评论内容
  content = ''

  // 父级ID
  pid = null

  invalid () {
    if (!this.content) return '内容不能为空'
  }
}

export default CommentForm
